import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { Pager } from '~core/models';

/**
 * Component that creates and operates the pagination
 */
@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html'
})

export class PaginatorComponent implements OnInit {
  @Input() public pager: Pager;
  @Input() public viewList: Array<number>;

  @Output() public setPageEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Output() public setViewEmitter: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  public i18nShowing: any = $localize`:@@general.text.showing:showing`;

  public i18nOf: any = $localize`:@@general.text.of:of`;

  ngOnInit(): void {}

  /**
   * Set the page and emit the value to the parent component so it can call the API.
   */
  public setPage(page: number): void {
    this.setPageEmitter.emit(page);
  }

  /**
   * Set the items per page and emit the value to the parent component so it can call the API.
   */
  public setView(itemsPerPage: number): void {
    this.setViewEmitter.emit(itemsPerPage);
  }

  get showingText(): string {
    let finalString = `${this.i18nShowing} `;
    finalString += `${this.pager.startIndex + 1} - ${this.pager.endIndex + 1} `;
    finalString += `${this.i18nOf} `;
    finalString += `${this.pager.totalItems}`;
    return finalString;
  }

}
